/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCreateAndEditDrawerTemplate = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h20v20H2V2zm2 2v16h8V4H4zm10 0v16h6V4h-6zm5 4h-4V6h4v2zm0 4h-4v-2h4v2zm0 4h-4v-2h4v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCreateAndEditDrawerTemplate as CreateAndEditDrawerTemplate };
